import { Warehouse, Store, Building2, Home, Factory, Package, MapPin, Truck } from "lucide-react";

export const WH_ICONS = { warehouse: Warehouse, store: Store, building: Building2, home: Home, factory: Factory, package: Package, pin: MapPin, truck: Truck };
export const WH_ICON_LABEL = { warehouse: "Entrepôt", store: "Boutique", building: "Immeuble", home: "Maison", factory: "Usine", package: "Colis", pin: "Lieu", truck: "Camion" };
export const DEFAULT_WH_COLOR = "#14b8a6";

export const WarehouseIcon = ({ warehouse, size = 18, className = "" }) => {
  const Icon = WH_ICONS[warehouse?.icon] || Warehouse;
  return <span className={`inline-flex items-center justify-center rounded-md text-white ${className}`} style={{ background: warehouse?.color || DEFAULT_WH_COLOR, width: size * 2, height: size * 2 }}><Icon size={size} /></span>;
};

export const WarehouseBadge = ({ name, color, icon, testId }) => {
  const Icon = WH_ICONS[icon] || Warehouse;
  return <span className="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-semibold text-white" style={{ background: color || DEFAULT_WH_COLOR }} data-testid={testId}><Icon size={12} /> {name}</span>;
};
